import { gql } from 'apollo-angular';

export const offersFieldsV2 = `
  edges {
    cursor
    node {
      id
      title
      text
      href
      linkText
      titleImageId
      publishedAt
      pinned
    }
  }
  pageInfo {
    hasPreviousPage
    hasNextPage
    startCursor
    endCursor
  }
`;

export const offersQueryV2 = gql`
  query publishedOffersV2($limit: Int, $offset: Int) {
    publishedOffersV2 (limit: $limit, offset: $offset) {
      ${offersFieldsV2}
    }
  }
`;

export const offerFieldsV2 = `
  id
  title
  text
  publishedAt
  titleImageId
  href
  linkText
`;

export const offerQueryV2 = gql`
  query getOfferV2($offerId: String!) {
    getOfferV2 (offerId: $offerId) {
      ${offerFieldsV2}
    }
  }
`;

// publishedOffersPublic is not part of the content V2 migration and keeps the V1 bean, which still
// exposes the title image as a plain url and names the body `body`.
export const publishedOffersPublicQuery = gql`
  query publishedOffersPublic($limit: Int, $offset: Int) {
    publishedOffersPublic(limit: $limit, offset: $offset) {
      edges {
        cursor
        node {
          id
          title
          text: body
          href
          linkText
          imageUrl
          publishedAt
          pinned
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;
